import axios from "axios"
import { v4 as uuidv4 } from "uuid"
const crypto = require("crypto")
//试卷宝引流测试环境
// const FRONTEND_BASE_URL = 'https://test-bookh5.xesvip.cn/paper/#'
// const MOBILE_FRONTEND_BASE_URL = 'https://test-bookh5.xesvip.cn/mpaper/#'
// const API_PROD_BASE_URL = 'https://api.xesvip.cn'

//试卷宝引流正试环境
const FRONTEND_BASE_URL = 'https://paper.xesvip.cn'
const MOBILE_FRONTEND_BASE_URL = 'https://paper.xesvip.cn'
const API_PROD_BASE_URL = 'https://api.xesvip.cn'

const API_DEV_BASE_URL = ''
const HOST_PAPER_RIGHT_LIST_MAX = 10
const API_SIGN_CONFIG = {
    appId: '100001',
    secret: 'w1KMkUnUmaCbfVOuKYuNBpmsCwPqrS32FcHWNoTp'
}
import MixinSite from "@/mixins/site";

export default {
    mixins: [MixinSite],
    apiRequestCommonParams(traceId) {
        return [
            {
                key: 'x-aio-appid',
                value: API_SIGN_CONFIG.appId,
                signField: true,
            },
            {
                key: 'x-aio-trace-id',
                value: traceId,
                signField: true,
            },
            {
                key: 'x-aio-mallid',
                value: 1,
                signField: false,
            },
            {
                key: 'client',
                value: 'zhanqun',
                signField: true,
            },
            {
                key: 'client-version',
                value: 'v2.9.0',
                signField: true,
            },
            {
                key: 'source',
                value: 7,
                signField: true,
            },
            {
                key: 'channel',
                value: 1,
                signField: true,
            },
            {
                key: 'services-version',
                value: '48',
                signField: true,
            },
            {
                key: 'time',
                value: parseInt(new Date().getTime() / 1000),
                signField: true,
            }
        ]
    },
    apiRequestCommonParamsDict() {
        let ret = {}
        const traceId = uuidv4()
        for (const item of this.apiRequestCommonParams(traceId)) {
            ret[String(item.key)] = item.value
        }
        ret['sign'] = this.sign(API_SIGN_CONFIG.secret, traceId)
        return ret
    },
    sign(key, traceId) {
        const params = this.apiRequestCommonParams(traceId)
        let paramKeys = []
        let paramKeyVal = {}
        for (const item of params) {
            if (item.signField) {
                let key = String(item.key)
                paramKeys.push(key.toLowerCase())
                paramKeyVal[key] = item.value
            }
        }
        paramKeys = paramKeys.sort()

        let signVals = [key]
        for (const key of paramKeys) {
            signVals.push(paramKeyVal[key])
        }
        signVals.push(key)

        let stringToSign = signVals.join("@")
        const sign = crypto.createHash('md5').update(stringToSign).digest('hex').toUpperCase()

        return sign
    },
    getApiBaseUrl() {
        if (process.env.NODE_ENV !== 'production') {
            return API_DEV_BASE_URL
        } else {
            return API_PROD_BASE_URL
        }
    },
    getSubjectKey(subject) {
        return `subject${subject}`
    },
    getPcHomePageUrl(params = {}) {
        const query = this.buildQueryString(params)
        const prefix = query ? '?' : ''
        return `${FRONTEND_BASE_URL}${prefix}${query}`
    },
    getMobileHomePageUrl(params = {}) {
        const query = this.buildQueryString(params)
        const prefix = query ? '?' : ''
        return `${MOBILE_FRONTEND_BASE_URL}${prefix}${query}`
    },
    getMobileSearchPageUrl(params = {}) {
        const query = this.buildQueryString(params)
        const prefix = query ? '?' : ''
        return `${MOBILE_FRONTEND_BASE_URL}/search${prefix}${query}`
    },
    getFrontendBaseUrl() {
        return FRONTEND_BASE_URL
    },
    getMobileFrontendBaseUrl() {
        return MOBILE_FRONTEND_BASE_URL
    },
    getDivisionIdByGrade(grade) {
        grade = parseInt(grade)
        if (grade <= 6) {
            return 1
        } else if (grade <= 9) {
            return 2
        } else {
            return 3
        }
    },
    commonParams: function (params) {
        let data = {
            grade: '',
            subject: '',
            classify: '',
            keyword: '',
            divisionId: '',
            utm_source: ''
        }
        let ret = {}
        for (let key in params) {
            if (data[key] != undefined) {
                ret[key] = params[key]
            }
        }
        return ret
    },
    buildPcPaperUrl: function (id, params = {}) {
        let p = { ...params }
        p.paper_id = id
        const query = this.buildQueryString(p)
        return `${FRONTEND_BASE_URL}/single-paper?` + query
    },
    buildMobilePaperUrl: function (id, params = {}) {
        let p = { ...params }
        p.paper_id = id

        const query = this.buildQueryString(p)
        return `${MOBILE_FRONTEND_BASE_URL}/single-paper?` + query
    },
    buildQueryString(params) {
        let query = []
        for (let key in params) {
            query.push(`${key}=` + encodeURIComponent(params[key]))
        }
        return query.join('&')
    },
    hotPaperTitle() {
        return '本地名校试卷'
    },
    queryHotPaper: function (params) {
        return new Promise((resolve, reject) => {
            axios.post(this.getApiBaseUrl() + `/contentapi/exampaper/query`, params, {
                headers: { 'Content-Type': 'application/json', ...this.apiRequestCommonParamsDict() }
            }).then((res) => {
                let tempData = res.data
                if (res.data.data.list) {
                    tempData.data.list = res.data.data.list.slice(0, HOST_PAPER_RIGHT_LIST_MAX)
                }
                resolve(tempData)
            }).catch(err => {
                reject(err)
            })
        })
    },
    queryDictionary: function () {
        return new Promise((resolve, reject) => {
            axios.post(this.getApiBaseUrl() + `/contentapi/exampaper/dictionary`, {}, {
                headers: { 'Content-Type': 'application/json', ...this.apiRequestCommonParamsDict() },

            }).then((res) => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    },
    trackEvent(name, attributes) {
        console.log(name, attributes)
        window.sensors && window.sensors.track(name, attributes)
    }
}